import { exists, removeDBObjectKeys, tsValidateArray, tsValidateMustExist, tsValidateNumber, tsValidateOptionalObject, tsValidateResult, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { EHRInstallationTypes } from '../ehr-installation/index.js';
import { EpicFhirAuthMode_Jwks, Validator_EpicFhirAuthMode } from '../../../_enum/epic-fhir-auth-mode/index.js';
import { EpicKeyRings } from '../../../_enum/epic-keyring/types.js';
import { Validator_FhirEpicEnv } from '../../../_enum/fhir-epic-env/validator.js';
const Validator_MandatoryPropsEnvironment = {
    label: tsValidateString(),
    type: tsValidateValue([...EHRInstallationTypes]),
    ehrInstallationId: tsValidateUniqueId,
    envDigit: tsValidateNumber(false),
};
const tsEnvEpicDemoPatientValidator = {
    label: tsValidateString(-1),
    patientId: tsValidateString(-1),
};
export const tsMCPDemoPatientValidator = {
    label: tsValidateString(-1),
    fhirPatient: tsValidateString(-1),
    encounterFhirId: tsValidateString(-1),
    epicIdToken: tsValidateString(-1),
    gatewayUrl: tsValidateString(-1, false),
    sdJwt: tsValidateString(-1, false),
    emr: tsValidateValue(['epic'], false),
    parentFrameUrl: tsValidateString(-1, false),
    userName: tsValidateString(-1, false),
    userFullName: tsValidateString(-1, false),
    userFirstName: tsValidateString(-1, false),
    userLastName: tsValidateString(-1, false),
    userEmail: tsValidateString(-1, false),
    userNPI: tsValidateString(-1, false),
    patientFirstName: tsValidateString(-1, false),
    patientLastName: tsValidateString(-1, false),
    encounterUniqueId: tsValidateString(-1, false),
    encounterDate: tsValidateString(-1, false),
    launchTimestamp: tsValidateString(-1, false),
};
const Validator_FHIRConfig = {
    ...Validator_MandatoryPropsEnvironment,
    authInterfaceProfile: tsValidateOptionalObject({
        advisorClientId: tsValidateString(-1, false),
        agentClientId: tsValidateString(-1, false),
        fhirAuthUrl: tsValidateString(-1, false),
        fhirBaseUrl: tsValidateString(-1, false),
        iss: tsValidateString(-1, false),
        fhirAuthMode: Validator_EpicFhirAuthMode,
        keyring: tsValidateValue([...EpicKeyRings], false),
        _jku: tsValidateString(-1, false),
        _jwksKidEnv: Validator_FhirEpicEnv,
        publicKey: tsValidateString(-1, false),
        secretPaths: tsValidateOptionalObject({
            privateKey: tsValidateString(-1, false),
            cert: tsValidateString(-1, false),
        }),
    }),
    demoPatients: tsValidateArray(tsEnvEpicDemoPatientValidator, false)
};
const Validator_MandatoryPropsForMCP = {
    ...Validator_MandatoryPropsEnvironment,
    authInterfaceProfile: tsValidateOptionalObject({
        fusionAuthUrl: tsValidateString(-1, false),
        sdjwtAuthUrl: tsValidateString(-1, false),
        authConnectionId: tsValidateString(-1, false),
        solutionId: tsValidateString(-1, false),
        fhirBaseUrl: tsValidateString(-1, false),
        grantType: tsValidateString(-1, false),
        scope: tsValidateString(-1, false),
        deployUserSecretId: tsValidateString(32, false),
        _deployUserId: (value) => {
            if (!exists(value))
                return;
            return 'NEVER SAVE SECRET VALUE';
        },
    }),
    demoPatients: tsValidateArray(tsMCPDemoPatientValidator, false)
};
const Validator_ModifiablePropsV2 = (environment) => {
    if (!environment)
        return 'got no environment to validate';
    const environmentToValidate = removeDBObjectKeys(environment);
    if (environmentToValidate?.type === 'epic') {
        const fieldResult = tsValidateResult(environmentToValidate, Validator_FHIRConfig);
        if (fieldResult)
            return fieldResult;
        const profile = environmentToValidate.authInterfaceProfile;
        if (profile?.fhirAuthMode === EpicFhirAuthMode_Jwks && !profile.keyring)
            return 'Epic JWKS auth requires keyring';
        return;
    }
    if (environmentToValidate?.type === 'deploy')
        return tsValidateResult(environmentToValidate, Validator_MandatoryPropsForMCP);
    return tsValidateMustExist(environmentToValidate) ?? `unsupported type ${environment?.type}`;
};
const Validator_GeneratedProps = {};
export const DBDef_Environment = {
    modifiablePropsValidator: Validator_ModifiablePropsV2,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'environments',
    generatedProps: [],
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'ehr-environment'
    },
    backend: {
        name: 'environments'
    },
    entityName: 'EHR Environments',
    dependencies: {
        ehrInstallationId: {
            dbKey: 'ehr-installations',
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map